import { render, staticRenderFns } from "./ModalToken.vue?vue&type=template&id=2b5fb830&scoped=true"
import script from "./ModalToken.vue?vue&type=script&lang=js"
export * from "./ModalToken.vue?vue&type=script&lang=js"
import style0 from "./ModalToken.vue?vue&type=style&index=0&id=2b5fb830&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5fb830",
  null
  
)

export default component.exports